// extracted by mini-css-extract-plugin
export default {"modal":"Lwcgq","modal-background":"MW0DO","image":"jQ62u","message":"g_Yam","button":"E4yzY"};